import React from 'react';
import Text, { Inline } from 'components/base/Text';
import { Padding, Flex } from 'components/base/layout-components';
import { Tooltip } from '@material-ui/core';
import * as LighthouseService from 'common/services/lighthouse.service';
import { ARTICLE_IDS } from 'common/constants/constants';
import styled from 'styled-components';
import unmatchedBranchesTooltipImg from 'images/unmatched-branches-tooltip.svg';
import { HyperLink } from 'components/base/HyperLink';

const StyledSVG = styled.img`
  margin-bottom: 1.5rem;
`;

const TooltipContent = () => {
  return (
    <Flex>
      <Padding t='medium' b='medium' r='small' l='small' width='26rem'>
        <StyledSVG src={unmatchedBranchesTooltipImg} />
        <Flex mt='small' direction='column'>
          <Inline size='large' weight={500} color='shark' pb='2rem'>
            What are unlinked Branches?
            <br />
            <Text
              size='large'
              weight={400}
              lineHeight='2rem'
              color='shuttleGray'
              mt='0.7rem'
            >
              Unlinked branches are branches your team is working on that do not
              match any project issues.
            </Text>
          </Inline>
          <Inline size='large' weight={500} color='shark'>
            What can I do to fix this?
            <br />
            <Text
              size='large'
              weight={400}
              pt='0.7rem'
              lineHeight='2rem'
              color='shuttleGray'
            >
              To help match branches and issues - include the issue ID in the
              branch name or in the pull request name or in a commit message.
            </Text>
            <Flex items='center' mt='medium'>
              <HyperLink
                onClick={e => {
                  e.stopPropagation();
                  e.preventDefault();
                  LighthouseService.navigateArticle(ARTICLE_IDS.PULSE_NAMING);
                }}
              >
                learn more
              </HyperLink>
            </Flex>
          </Inline>
        </Flex>
      </Padding>
    </Flex>
  );
};

const UnmatchedBranchesTooltip = ({ children, placement = 'bottom-start' }) => {
  return (
    <Tooltip title={<TooltipContent />} placement={placement} interactive>
      {children}
    </Tooltip>
  );
};

export default UnmatchedBranchesTooltip;
